import { ProgramId, ProgramLevel } from '../programs'
import { FacilityId } from '../facilities'
import { TimetableId } from '../timetables'
import { UserId } from '@/core/Auth'
import { Activity } from '@/core/Activities'

export type ReservationRequestId = string // UUID

export interface CreateReservationRequestParams {
  facilityId: FacilityId
  programId: ProgramId
  timetableIds:
    | []
    | [TimetableId]
    | [TimetableId, TimetableId]
    | [TimetableId, TimetableId, TimetableId]
}

export interface CanRequestResponse {
  canRequest: boolean
}

export interface ReservationRequestTimetable {
  id: TimetableId
  quantity: number
  point: number
  programId: ProgramId
  facilityId: ProgramId
  startAt: string
  endAt: string
  reservationDeadline: string
  cancelDeadline: string
  instructor: string
  stock: number
}

export type ListTimetablesResponse = ReservationRequestTimetable[]

export enum ReservationRequestStatus {
  REQUESTED = 'requested',
  CANCELED = 'canceled',
  APPROVED = 'approved',
  DENIED = 'denied',
  CONFIRMED = 'confirmed',
}

export interface MyRequestsResponse {
  id: ReservationRequestId
  userId: UserId
  facility: {
    id: FacilityId
    name: string
    prefecture: string
    address: string
    distance: string
    isOnline: boolean
    latitude: number | null
    longitude: number | null
  }
  program: {
    id: ProgramId
    name: string
    image: string
    level: ProgramLevel
    minuteAgo: number
    duration: number
    activities: Activity[]
  }
  timetables: {
    id: TimetableId
    startAt: string
    priority: 1 | 2 | 3
  }[]
  approvedTimetable: {
    id: TimetableId
    startAt: string
    point: number
    instructor: string
  }
  createdAt: string
  approvedAt: string | null
  deniedAt: string | null
  confirmedAt: string | null
  confirmationDeadline: string | null
  status: ReservationRequestStatus
}
